//#region src/compat/util/stubObject.ts
/**
* Returns an empty object.
*
* @returns {Object} An empty object.
* @example
* stubObject() // Returns {}
*/
function stubObject() {
	return {};
}
//#endregion
export { stubObject };
